import { api } from '../index.js'

export default {
  namespaced: true,

  state: {
    categories: []
  },

  mutations: {
    updateCategories(state, categories) {
      state.categories = categories
    }
  },

  actions: {
    async fetchAll({ commit, state }) {
      let [categories] = await api.campaign_categories.all()
      commit('updateCategories', categories)
    }
  }
}
